import styled from "styled-components";

export const CreateYahrzeitAlertContainer = styled.div`
 display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

export const CreateYahrzeitAlertTitle = styled.div`
  font-size: 16px;
  width: 100%;
  text-align: center;
`;
export const CreateYahrzeitAlertAction = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const CreateYahrzeitAlertButton = styled.button`
  min-width: 100px;
  font-size: 14px;
`;
